import React from 'react';
type BookCoverProps = {
  kicker: string;
  title: string;
  number?: string;
  accent?: string;
  size?: 'sm' | 'md';
  className?: string;
};

/** Code-drawn cover in the product look: white page, accent band, a volleyball. */
export function BookCover({
  kicker,
  title,
  number,
  accent = 'bg-coral',
  size = 'md',
  className = ''
}: BookCoverProps) {
  const sm = size === 'sm';
  return <div className={`relative aspect-[3/4] overflow-hidden rounded-[10px] bg-white shadow-book ${className}`} data-id="element-42" data-mp="2o66niipiqj84">
      <span className={`absolute inset-x-0 top-0 h-[22%] ${accent}`} aria-hidden="true" data-id="element-43" data-mp="2jeoo3z358qp9" />
      <svg viewBox="0 0 120 60" className="absolute bottom-[10%] left-[10%] w-[80%]" aria-hidden="true" data-id="element-44" data-mp="2efbvsyti6rfa">
        <line x1="4" y1="50" x2="116" y2="50" stroke="#E7E1D4" strokeWidth="3" strokeLinecap="round" data-id="element-45" data-mp="29hjyfpa3ad3p" />
        <path d="M14 50 C 40 10, 80 10, 106 50" stroke="#2348C4" strokeWidth="1.6" strokeDasharray="4 4" fill="none" data-id="element-46" data-mp="24gmfhah99f15" />
        <g transform="translate(60 24)" data-id="element-47" data-mp="20gm27t5w79vo">
          <circle cx="0" cy="0" r="9" fill="#FFFFFF" stroke="#122143" strokeWidth="1.4" data-id="element-48" data-mp="19are7935dptn" />
          <path d="M-8 -4 C -1 0, 3 4, 7 9" fill="none" stroke="#122143" strokeWidth="1.1" data-id="element-49" data-mp="198y4fkx8mphf" />
          <path d="M0 -9 C 1 -2, 0 3, 3 9" fill="none" stroke="#122143" strokeWidth="1.1" data-id="element-50" data-mp="1e3kg7p78ek21" />
          <path d="M-9 2 C -2 2, 4 0, 9 -3" fill="none" stroke="#122143" strokeWidth="1.1" data-id="element-51" data-mp="zaie3k61bk8z" />
        </g>
        <circle cx="14" cy="50" r="3.2" fill="#2348C4" data-id="element-52" data-mp="149lmnel848lp" />
        <circle cx="106" cy="50" r="3.2" fill="#F5832B" data-id="element-53" data-mp="1s2ahzi4zx7wq" />
      </svg>
      <div className="relative flex h-full flex-col px-[11%] pt-[30%]" data-id="element-54" data-mp="1x03jhxvctdqo">
        <p className={`font-display font-bold uppercase tracking-[0.18em] text-slate ${sm ? 'text-[7px]' : 'text-[9px]'}`} data-id="element-55" data-mp="1wy97xa5z2xz9">
          {kicker}
        </p>
        {number && <p className={`mt-1 font-display font-extrabold leading-none text-cloud-dark ${sm ? 'text-3xl' : 'text-5xl'}`} data-id="element-56" data-mp="1n0l3fsikec3w">{number}</p>}
        <p className={`mt-2 font-display font-extrabold leading-[1.02] tracking-tight text-ink ${sm ? 'text-[13px]' : 'text-[19px]'}`} data-id="element-57" data-mp="bmr26hoep988">
          {title}
        </p>
        <p className={`mt-2 font-semibold uppercase tracking-widest text-slate-soft ${sm ? 'text-[5.5px]' : 'text-[7px]'}`} data-id="element-58" data-mp="2e8wciyzedabn">
          52 Weeks of Volleyball Practice Plans
        </p>
      </div>
    </div>;
}